import script from "./WriteOffRule.vue?vue&type=script&setup=true&lang=js"
export * from "./WriteOffRule.vue?vue&type=script&setup=true&lang=js"

import "./WriteOffRule.vue?vue&type=style&index=0&id=21da8cea&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/h5-subscription-client-prod-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21da8cea"]])

export default __exports__